console.log('init: jquery-js'); // eslint-disable-line no-console

const jQuery = require('jquery');
module.exports = jQuery;
